// Play shell (gameplay 2027): marks <body> with `tc-play-scrolled` once the page
// is scrolled past a small offset. The CSS (_station.scss) then tucks the pinned
// stats bar away and lets the countdown stick right under the header; back at
// the top the stats bar returns. `tc-play-scroll-ready` is set on the first real
// scroll, so nothing animates while the page loads. Listens in the capture phase,
// so it also sees the inner scroll container (.singha-body), not only the window.

const SCROLLED = 'tc-play-scrolled';
const READY = 'tc-play-scroll-ready';
// below this offset the stats bar shows
const MIN_OFFSET = 60;

function onScroll(e: Event): void {
	const target = e.target === document ? document.scrollingElement : e.target;
	if (!(target instanceof Element)) {
		return;
	}

	document.body.classList.add(READY);
	document.body.classList.toggle(SCROLLED, target.scrollTop > MIN_OFFSET);
}

// a new page starts without the scrolled state — no hidden bar, no animation carried over
function reset(): void {
	document.body.classList.remove(SCROLLED, READY);
}

// The app scrolls inside .singha-body (on phones the play views scroll the page,
// see _play-shell.scss), and Blazor does not reliably reset either on navigation —
// without this a new page opens at the previous page's offset (e.g. "Weiter
// geht's" on the welcome screen → stations list half-scrolled). Only when the
// path changes, so query/hash updates keep their position.
function scrollToTop(url: string | URL | null | undefined): void {
	if (url == null || new URL(url, location.href).pathname === location.pathname) {
		return;
	}

	document.querySelectorAll('.singha-layout, .singha-layout .singha-body').forEach((el) => {
		el.scrollTop = 0;
	});
	// instant: the root has scroll-behavior: smooth (Singha)
	window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
}

function patchHistory(method: 'pushState' | 'replaceState'): void {
	const original = history[method].bind(history);
	history[method] = (...args: Parameters<History['pushState']>) => {
		reset();
		if (method === 'pushState') {
			scrollToTop(args[2]);
		}
		return original(...args);
	};
}

export function initPlayScroll(): void {
	document.addEventListener('scroll', onScroll, { capture: true, passive: true });
	window.addEventListener('popstate', reset);
	patchHistory('pushState');
	patchHistory('replaceState');
}
